import getNewsMapper from '@/utils/newsMapper'
import movingAverage from '@/utils/newsMovingAverage'
import { get as _get, isArray as _isArray, isString as _isString } from 'lodash'

const newsTypes = {
  magazines: 'mag',
  socials: 'soc',
  picked: 'pck',
}
export default {
  namespaced: true,
  state: {
    // TODO: mode: 'socials',
    search: {
      magazines: false,
      socials: false,
      picked: false,
    },
    news: {
      magazines: [],
      socials: [],
      picked: [],
    },
    statistics: {
      magazines: [],
      socials: [],
      picked: [],
    },
    statisticsMentions: {
      magazines: [],
      socials: [],
      picked: [],
    },
    average: {
      magazines: 0.5,
      socials: 0.5,
      picked: 0.5,
    },
  },
  mutations: {
    updateNews(state, { news, clean = false }) {
      if (!state.news || clean)
        state.news = {
          magazines: [],
          socials: [],
          picked: [],
        }

      if (_isArray(news.magazines)) {
        state.news.magazines.push(...news.magazines.map(getNewsMapper('mag')))
      }
      if (_isArray(news.socials)) {
        state.news.socials.push(...news.socials.map(getNewsMapper('soc')))
      }
      if (_isArray(news.picked)) {
        state.news.picked.push(...news.picked.map(getNewsMapper('pck')))
      }
    },
    updateSearch(state, { type, news }) {
      if (!_isArray(news)) {
        state.search[type] = false
        return
      }

      state.search[type] = news.map(getNewsMapper(newsTypes[type]))
    },
    updateStatistics(state, stats) {
      if (
        (!_isArray(stats.magazines) || !_isArray(stats.socials)) &&
        !_isArray(stats.picked)
      )
        return

      state.statistics = {
        magazines: movingAverage(stats.magazines),
        socials: movingAverage(stats.socials),
        // just copy socials this time
        picked: movingAverage(stats.socials),
      }
      state.statisticsMentions = {
        magazines: stats.magazines,
        socials: stats.socials,
        // just copy socials this time
        picked: stats.socials,
      }

      if (state.statistics.magazines.length > 1) {
        state.average.magazines = state.statistics.magazines.slice(
          0,
          1
        )[0].value
      }
      if (state.statistics.socials.length > 1) {
        state.average.socials = state.statistics.socials.slice(0, 1)[0].value
      }
      // Already getting first from picked
      if (state.statistics.picked.length > 1) {
        state.average.picked = state.statistics.picked.slice(0, 1)[0].value
      }
    },
  },
  actions: {
    updateAll({ dispatch, commit, rootState }) {
      dispatch(
        'request/getNews',
        { ticker: rootState.market.ticker },
        { root: true }
      )
        .then((news) => {
          commit('updateNews', { news: news, clean: true })
        })
        .catch((err) => {
          dispatch(
            'layout/showMessage',
            {
              title: 'Error',
              message: `Getting news ${err}`,
              type: 'error',
            },
            { root: true }
          )
        })

      dispatch(
        'request/getNewsStatistics',
        { ticker: rootState.market.ticker },
        { root: true }
      )
        .then((stats) => {
          commit('updateStatistics', stats)
        })
        .catch((err) => {
          dispatch(
            'layout/showMessage',
            {
              title: 'Error',
              message: `Getting news statistics ${err}`,
              type: 'error',
            },
            { root: true }
          )
        })
    },
    updateAllForType({ dispatch, commit, rootState }, { type = 'socials' }) {
      dispatch(
        'request/getNews',
        { ticker: rootState.market.ticker, type },
        { root: true }
      )
        .then((news) => {
          commit('updateNews', { news: news, clean: true })
        })
        .catch((err) => {
          dispatch(
            'layout/showMessage',
            {
              title: 'Error',
              message: `Getting news for ${type} ${err}`,
              type: 'error',
            },
            { root: true }
          )
          throw err
        })

      dispatch(
        'request/getNewsStatistics',
        { ticker: rootState.market.ticker, type },
        { root: true }
      )
        .then((stats) => {
          commit('updateStatistics', stats)
        })
        .catch((err) => {
          dispatch(
            'layout/showMessage',
            {
              title: 'Error',
              message: `Getting news statistics ${err}`,
              type: 'error',
            },
            { root: true }
          )
        })
    },
    search({ rootState, dispatch, commit }, { type, query }) {
      if (type !== 'magazines' && type !== 'socials') return
      if (!_isString(query) || query.length === 0) {
        commit('updateSearch', { type })
        return
      }

      dispatch(
        'request/searchNews',
        { ticker: rootState.market.ticker, type, query },
        { root: true }
      )
        .then((news) => {
          commit('updateSearch', { type, news })
        })
        .catch((err) => {
          if (
            _get(err, 'response.data.name', 'DefaultErr') == 'ValidationError'
          ) {
            dispatch(
              'layout/showMessage',
              {
                title: 'Validation error',
                message: _get(
                  err,
                  'response.data.data[0].message',
                  'Less than 3 symbols in request'
                ),
                type: 'warning',
              },
              { root: true }
            )
          } else
            dispatch(
              'layout/showMessage',
              {
                title: 'Error',
                message: `Searching news ${err}`,
                type: 'error',
              },
              { root: true }
            )
        })
    },
  },
  getters: {},
}
